import { z } from 'zod';
import { createZodFetcher } from 'zod-fetch';

import { type Repub } from '@cx-modules/constants';

import { type SubsProduct } from '~/types/subs-product';

const fetchWithZod = createZodFetcher();

export const navigateToStripeManagement = async ({
  isUpgrade = false,
  repub,
  returnUrl,
  upgradeProduct,
}: {
  isUpgrade?: boolean;
  repub: Repub;
  returnUrl?: string;
  upgradeProduct?: SubsProduct;
}) => {
  const returnUrlParams = new URLSearchParams(
    isUpgrade
      ? {
          isUpgrade: 'true',
          price: upgradeProduct?.priceFormatted ?? '',
          term: upgradeProduct?.term ?? '',
          verifyPayment: 'true',
        }
      : {},
  );

  const searchParams = new URLSearchParams({
    returnUrl: `${returnUrl || window.location.href}?${returnUrlParams.toString()}`,
  });

  try {
    const { url } = await fetchWithZod(
      z.object({
        url: z.string(),
      }),
      `/api/cx/subscription/manage?${searchParams.toString()}`,
      {
        headers: {
          'OC-Repub': repub,
        },
      },
    );
    window.location.href = url;
  } catch (error) {
    console.error('Failed to navigate to Stripe:', error);
  }
};
